import { useEffect, useState } from 'react';
import { get_dimensions, get_metrics } from '../../services/api.service';
import { Modal, Button, Select } from 'antd';

const AddGraphical = ({ onChange, onClose, metrics, dimensions }) => {
  const handleOk = async () => {
    await onChange(Number(field_select_metrics), Number(field_select_dimensions));
    onClose();
  };

  const [field_select_metrics, set_select_field_metrics] = useState(1);
  const [field_select_dimensions, set_select_field_dimensions] = useState(0);

  const onChangeSelect = (value, type) => {
    if (type == 'metric') {
      set_select_field_metrics(value);
    } else {
      set_select_field_dimensions(value);
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <div>
      <Modal
        title="Chọn điều kiện biểu đồ"
        open={true}
        onOk={handleOk}
        onCancel={handleCancel}
        cancelButtonProps={{ hidden: true }}
      >
        <div className="flex gap-5 justify-center">
          <div className="flex flex-col gap-2">
            <div>
              <b>Chọn metrics</b>
            </div>
            <Select
              style={{ width: '200px', maxWidth: '400px' }}
              defaultValue={metrics?.[0]?.name}
              options={
                metrics.map((item) => {
                  return { label: item.name, value: item.id };
                }) || []
              }
              onChange={(e) => {
                onChangeSelect(e, 'metric');
              }}
            />
          </div>

          <div className="flex flex-col gap-2">
            <div>
              <b>Chọn Dimention</b>
            </div>

            <Select
              style={{ width: '200px', maxWidth: '400px' }}
              defaultValue={'Tất cả'}
              options={[
                { label: 'Tất cả', value: 0 },
                ...dimensions
                  .filter((item) => item.id != 1)
                  .map((item) => {
                    return { label: item.name, value: item.id };
                  }),
              ]}
              onChange={(e) => {
                onChangeSelect(e, 'dimension');
              }}
            />
          </div>
        </div>
      </Modal>
    </div>
    // <div style={{ top: '25%', left: '50%', position: 'absolute', width: '500px', height: '250px', textAlign: 'center', backgroundColor: '#ced4da', pointerEvents: 'auto', zIndex: '9999', transform: 'translateX(-50%)' }}>
    //     <div style={{ paddingLeft: '90%', paddingTop: '5%' }}>
    //         <span onClick={closepopup} className="btn-close"></span>
    //     </div>
    //     <div style={{ display: 'flex', gap: '30px' }}>
    //         <div style={{ flex: 1 }}>
    //             <span>
    //                 Chọn metrics
    //             </span>
    //             <span>
    //                 <section onChange={(e) => onChangeSelect(e, 'metric')}>
    //                     <select>
    //                         {
    //                             field_metrics && field_metrics.map((item, index) => {
    //                                 return <option value={item.id} key={item.id}>{item.name}</option>
    //                             })
    //                         }
    //                     </select>
    //                 </section>
    //             </span>
    //         </div>
    //         <div style={{ flex: 1 }}>
    //             <span>
    //                 Chọn Dimention
    //             </span>
    //             <span>
    //                 <section onChange={(e) => onChangeSelect(e, 'dimension')}>
    //                     <select>
    //                         <option value={0} key={0}>Tất cả</option>
    //                         {
    //                             field_dimensions && field_dimensions
    //                                 .filter(item => item.id != 1)
    //                                 .map((item, index) => {
    //                                     return <option value={item.id} key={item.id}>{item.name}</option>
    //                                 })
    //                         }
    //                     </select>
    //                 </section>
    //             </span>
    //         </div>
    //     </div>
    //     <div className="pt-5">
    //         <span onClick={AddGraphi} className="btn btn-info">Thêm</span>
    //     </div>
    // </div>
  );
};
export default AddGraphical;
